import React, {useEffect, useState, useRef} from 'react';
import { useHistory } from "react-router-dom";
import { set, get, remove } from '../../services/storage.service';
import { saveMindset, loadMindset, checkMindset, removeMindset } from '../../services/local.mindset';
import axios from 'axios';
import {
    IonPage,
    IonContent, 
    IonSlide, IonSlides, 
    IonCard,
    IonText,
    IonButton,IonToolbar,IonIcon,
    IonRadioGroup,IonRadio,
    IonListHeader, IonItem,
    IonTextarea,IonToggle,IonAlert,IonList,IonInput,IonCheckbox,IonLoading,IonLabel,
    IonSelect,IonSelectOption,
    IonRow,IonCol, IonGrid,
    IonHeader,
    IonFabButton,
    isPlatform
} from '@ionic/react';
import { Capacitor } from '@capacitor/core';
import { logOutOutline, chevronBackOutline, arrowForwardOutline, arrowBackOutline } from 'ionicons/icons';
import FooterCom from '../../components/FooterComponent';
import LoginCheck from "../../components/LoginCheck";
import './CreateMindset.css';


const CreateMindset: React.FC = () => {
    
    var error = false;
    //declare all the variables 
    const [mindset,setMindsetDef] = useState<string>('To me, an Explorer Mindset...');
    const [curiosity,setCuriosityDef] = useState<string>('Being curious helps me to...');
    const [responsibility,setResponsibilityDef] = useState<string>('Being responsible means I...');
    const [empowerment,setEmpowermentDef] = useState<string>('When I think of myself as an explorer, I am empowered because...');

    //secondary variables
    const [wonderawe,setWonderAweDef] = useState<string>('I appreciate the beauty and all there is to discover about world around me');
    const [adventurousness,setAdventurousnessDef] = useState<string>('I seek out new and challenging experiences');
    const [respect,setRespectDef] = useState<string>('I appreciate the beauty and all there is to discover about world around meI am respectful. I consider multiple perspectives, and honor others regardless of differences. I respect resources of all kinds, and I leave a place better than I found it (Stewardship)I respect myself by staying true to myself and making choices that are good for my well being');
    const [empathy,setEmpathyDef] = useState<string>('I understand others perspectives and demonstrate empathy');
    const [grit,setGritDef] = useState<string>('I can use what I already know to solve problems and persevere in solving themI seek out new and challenging experiences');
    const [adaptability,setAdaptabilityDef] = useState<string>('I can adapt adjust my path when exploring (Plan A, B, C, etc)');
    const [growthmindset,setGrowthmindsetDef] = useState<string>('I strive for continuous growth in myself and others, I know setbacks and obstacles will occur but when they do, I have grit.');
    const [focus,setFocusDef] = useState<string>('I can center my attention on a task, interest or activity');
    const [datacollecting,setDatacollectingDef] = useState<string>('I can collect, organize and analyze data');
    const [reasoning,setReasoningDef] = useState<string>('I can reason abstractly and quantitatively; with concepts, data and numbers.  I am a critical thinker and can make well-reasoned decisions');
    const [creativity,setCreativityDef] = useState<string>('I practice inventiveness and ingenuity, I brainstorm multiple options to develop an idea. I take creative risks as part of research and development and learn from mistakes.');


    //attitude icons
    const [curiosityicon, setCuriousityIcon] = useState<string>('curiosity1.png');
    const [responsibilityicon, setResponsibilityIcon] = useState<string>('responsibility1.png');
    const [empowermenticon, setEmpowermentIcon] = useState<string>('empowerment1.png');
    //skills
    const [observation,setObservationDef] = useState<string>('Being observant means...Things I like to observe are...');
    const [communication,setCommunicationDef] = useState<string>('A good communicator...I am a good communicator when I...');
    const [collaboration,setCollaborationDef] = useState<string>('A collaborator...I am a collaborator when I...');
    const [problemsolving,setProblemsolvingDef] = useState<string>('A problem solver...I am a problem solver when I...');
    //skill icons
    const [communicationicon, setCommunicationIcon] = useState<string>('communication1.png');
    const [collaborationicon, setCollaborationIcon] = useState<string>('collaboration1.png');
    const [observationicon, setObservationIcon] = useState<string>('observation1.png');
    const [problemsolvingicon, setProblemsolvingIcon] = useState<string>('problemsolving1.png');
    //fields 
    const [expmindname, setExpmindName] = useState<string>('My Explorer Mindset');
    const [firstname, setFirstName] = useState<string>('');
    //const [lastname, setLastName] = useState<string>('');
    const [issuccess, setIssuccess] = useState<boolean>(false);
    const [winmessage, setWinMessage] = useState<string>("");
    const [winmessagetitle, setWinMessageTitle] = useState<string>("");
    const [color,setColor] = useState<any>("#42DD52");
    //const sendata;

    //toggles
    const [swiper, setSwiper] = useState<any>({});
    const [curiositycheck, setCuriosity] = useState<boolean>(false);
    const [mindsetcheck, setMindset] = useState<boolean>(false);
    const [responsibilitycheck, setResponsibility] = useState<boolean>(false);
    const [empowermentcheck, setEmpowerment] = useState<boolean>(false);
    const [levelcheck, setLevel] = useState<any>('1848');
    const [currentcheck, setCurrent] = useState<any>('0');
    const [isSaved, setIsSaved] = useState<any>('none');
    const [showLoading, setShowLoading] = useState(false);
    //icons

    //checkboxes
    const [wonderawechecked, setWonderAweChecked] = useState(false);
    const [adventurousnesschecked, setAdventurousnessChecked] = useState(false);
    const [respectchecked, setRespectChecked] = useState(false);
    const [empathychecked, setEmpathyChecked] = useState(false);
    const [gritchecked, setGritChecked] = useState(false);
    const [adaptabilitychecked, setAdaptabilityChecked] = useState(false);
    const [growthmindsetchecked, setGrowthMindsetChecked] = useState(false);
    const [focuschecked, setFocusChecked] = useState(false);
    const [datacollectingchecked, setDataCollectingChecked] = useState(false);
    const [reasoningchecked, setReasoningChecked] = useState(false);
    const [creativitychecked, setCreativityChecked] = useState(false);
    
    //toggle states
    const togglecuriosity = () => {setCuriosity(!curiositycheck);}
    const togglemindset = () => {setMindset(!mindsetcheck);}
    const toggleresponsibility = () => {setResponsibility(!responsibilitycheck);}
    const toggleempowerment = () => {setEmpowerment(!empowermentcheck);}

    const plat = isPlatform('mobileweb');
    const desk = isPlatform('desktop');

    let introurl = "public/assets/video/mindsetintro.mp4";
    let curiosityurl = "public/assets/video/curiosity.mp4";  
    let curiositynaturl = "public/assets/video/natgeocuriosity.mp4";
    let responsibilityurl = "public/assets/video/responsibility.mp4";
    let responsibilitynaturl = "public/assets/video/natgeoresponsibility.mp4";
    let empowermenturl = "public/assets/video/empowerment.mp4";
    let empowermentnaturl = "public/assets/video/natgeoempowerment.mp4";
    let skillseturl = "public/assets/video/skillset.mp4";

    if(plat || desk){
        introurl = "assets/video/mindsetintro.mp4";
        curiosityurl = "assets/video/curiosity.mp4";
        curiositynaturl = "assets/video/natgeocuriosity.mp4";
        responsibilityurl = "assets/video/responsibility.mp4";
        responsibilitynaturl = "assets/video/natgeoresponsibility.mp4";
        empowermenturl = "assets/video/empowerment.mp4";
        empowermentnaturl = "assets/video/natgeoempowerment.mp4";
        skillseturl = "assets/video/skillset.mp4";
    }else{
        introurl = "public/assets/video/mindsetintro.mp4";
        curiosityurl = "public/assets/video/curiosity.mp4";  
        curiositynaturl = "public/assets/video/natgeocuriosity.mp4";
        responsibilityurl = "public/assets/video/responsibility.mp4";
        responsibilitynaturl = "public/assets/video/natgeoresponsibility.mp4";
        empowermenturl = "public/assets/video/empowerment.mp4";
        empowermentnaturl = "public/assets/video/natgeoempowerment.mp4";
        skillseturl = "public/assets/video/skillset.mp4";
    }

    setTimeout(() => {
      setShowLoading(false);
    }, 2000);

    checkMindset(//see if we need to show the load button
    ).then(function (finalResul){
        //console.log(finalResul);
        setIsSaved(finalResul);
    }).catch(err => {
        //console.log("e: " + err.message);
    } );

    const history = useHistory();
    function logOut(){
        console.log("logout");
        remove('cred');
        history.push('/home');
    }
    const scrollTop = () =>{
       // document?.querySelector("ion-content")?.scrollToTop(500);
        contentRef.current && contentRef.current.scrollToTop(500);
    }
    const contentRef = useRef<HTMLIonContentElement | null>(null);
    //slides
    const handleSlidesControlNext = () =>{ 
        swiper.slideNext(300);document?.querySelector("ion-content")?.scrollToTop(500); 
        contentRef.current && contentRef.current.scrollToTop(500);//for ios
        console.log('scrolltop');
    }
    const handleSlidesControlPrev = () =>{ 
        swiper.slidePrev(300);document?.querySelector("ion-content")?.scrollToTop(500); 
        contentRef.current && contentRef.current.scrollToTop(500);//for ios
        console.log('scroll top');
    }

    const mySlides = useRef(null);
    const slideOpts = {
        initialSlide: 0,
        speed: 300,
        grabCursor: false,
        allowTouchMove: false,
    };

    //swiper
    const init = async function(this: any) {
        setSwiper(await this.getSwiper());
        setCurrent(0);
    };
    const getIndex = async (event: any) => {
        let index: number = 0;
        await event.target.getActiveIndex().then((value: any) => (index=value));
        setCurrent(index);
        //scroll to top
        document?.querySelector("ion-content")?.scrollToTop(500); 
    }
    
    //function to submit to wordpress //,formID:any
    function PosttoServer(bodyFormData:any){
        //var baseURL = 'https://expmindapp.wpengine.com/wp-json/'
        var baseURL = 'https://explorermindsetapp.com/wp-json/'
        //validate first 
        if(bodyFormData === ""){
            error = true;
        }else{
            error = false;
        }
        if(error){  
            setWinMessage('error');
        }else{
            let mylevel = levelcheck;
            //then send if it's good
            get("cred").then(function (finalResult) {
                const userD = JSON.parse(finalResult);
                const token = userD.authtoken;
                const email = userD.email;
                bodyFormData.set('post_title', email);
                bodyFormData.set('logged-email',email);
                console.log(bodyFormData);
                console.log("email grabbed");
                console.log(userD)
                //axios.post(baseURL + 'contact-form-7/v1/contact-forms/2638/feedback', 
                axios.post(baseURL + 'contact-form-7/v1/contact-forms/'+mylevel+'/feedback', 
                    bodyFormData,
                {
                headers: { 
                    'Authentication':' Bearer ' + token 
                },
                timeout:8000,
                }).then(function (serverResponse) {
                    setShowLoading(false);
                    const postsD = serverResponse.data;
                    console.log(postsD);
                    console.log("error should popup");
                    //setLoad(true);//submission was a success
                    if(serverResponse.data.message === 'You have created your mindset and it has been saved. Click on "My Account" from the main menu to access and plan an exploration with the "Create a Mind Map" button.'){
                        const message = "You can view it be logging into the website, it may take some time to appear in the app.";
                        setWinMessage(message);
                    }else{
                        setWinMessage(serverResponse.data.message);
                    }
                    
                    if(serverResponse.data.status === 'mail_sent'){
                        const title = "Your Mindset was saved to the server";
                        setWinMessageTitle(title);
                    }else{
                        const title = serverResponse.data.status
                        setWinMessageTitle(title);
                    }
                    
                    //setMessage(response.data.message);
                    
                    removeMindset().then(function(){
                        resetForm();
                    });

                    //removeMindset().then(function(){
                       // resetForm();
                        //resetForm();
                    //});
                })
                .catch(function (error) {
                    setShowLoading(false);
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        console.log(error.request)
                    } else {
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                    console.log(error);
                    const message = "Congratulations your Mindset should be saved, it will be saved to the website and app, it may take some time to appear in the app.";
                    setWinMessage(message);
                    removeMindset().then(function(){
                        resetForm();
                    });
                    //console.log(error.response.data);
                });
            }).catch(err => {//unable to load the local storage
                console.log("e: " + err.message);
            });
        }
    }
    function resetForm(){
        document?.querySelector("ion-content")?.scrollToTop(500);swiper.slideTo(0);
        //declare all the variables 
        setMindsetDef('To me, an Explorer Mindset...');
        setCuriosityDef('Practicing being curious helps me to...');
        setResponsibilityDef('Thinking about responsibility helps me to...');
        setEmpowermentDef('When I think of myself as an explorer, I am empowered because...');

        //attitude icons
        setCuriousityIcon('curiosity1.png');
        setResponsibilityIcon('responsibility1.png');
        setEmpowermentIcon('empowerment1.png');
        
        //skills
        setObservationDef('Being observant means...Things I like to observe are...');
        setCommunicationDef('A good communicator...I am a good communicator when I...');
        setCollaborationDef('A collaborator...I am a collaborator when I...');
        setProblemsolvingDef('A problem solver...I am a problem solver when I...');


        //skill icons
        setCommunicationIcon('communication1.png');
        setCollaborationIcon('collaboration1.png');
        setObservationIcon('observation1.png');
        setProblemsolvingIcon('problemsolving1.png');

        //fields 
        setExpmindName('My Explorer Mindset');
        setFirstName('');
        //setLastName('');
        setColor("#42DD52");
        setIssuccess(false);
        //checks
        setCuriosity(!curiositycheck);
        setMindset(!mindsetcheck);
        setResponsibility(!responsibilitycheck);
        setEmpowerment(!empowermentcheck);

        setResponsibility(false);
        setEmpowerment(false);
        setLevel('1848');
        setWonderAweChecked(false);
        setAdventurousnessChecked(false);
        setRespectChecked(false);
        setEmpathyChecked(false);
        setGritChecked(false);
        setAdaptabilityChecked(false);
        setGrowthMindsetChecked(false);
        setFocusChecked(false);
        setDataCollectingChecked(false);
        setReasoningChecked(false);
        setCreativityChecked(false);
        //definitions
        setIssuccess(true);
        console.log("popup");
    }
    function publishMM(
        savelevel:any,
        savemindset:any,
        savecuriositycheck:boolean,
        savecuriosity:any,
        savecuricon:any,
        saveempowermentcheck:boolean,
        saveempowerment:any,
        saveempicon:any,
        saveresponsibilitycheck:boolean,
        saveresponsibility:any,
        saveresicon:any,
        saveobservation:any, 
        saveobsicon:any,
        savecommunication:any, 
        savecomicon:any,
        savecollaboration:any, 
        savecolicon:any,
        saveproblemsolving:any,
        saveproicon:any,
        savefirstname:any,
        //savelastname:any,
        saveexptitle:any,
        savewonderawechecked:any,
        savewonderawe:any,
        saveadventurousnesschecked:any,
        saveadventurousness:any,
        saverespectchecked:any,
        saverespect:any,
        saveempathychecked:any,
        saveempathy:any,
        savegritchecked:any,
        savegrit:any,
        saveadaptabilitychecked:any,
        saveadaptability:any,
        savegrowthmindsetchecked:any,
        savegrowthmindset:any,
        savefocuschecked:any,
        savefocus:any,
        savedatacollectingchecked:any,
        savedatacollecting:any,
        savereasoningchecked:any,
        savereasoning:any,
        savecreativitychecked:any,
        savecreativity:any,
        
    ){
        setShowLoading(true);
        let bodyFormData = new FormData();
        let curiositycheck = "";
        let responsibilitycheck = "";
        let empowermentcheck = "";
        let wonderawecheck = "";
        let adventurousnesscheck = "";
        let respectcheck = "";
        let empathycheck = "";
        let gritcheck = "";
        let adaptabilitycheck = "";
        let growthmindsetcheck = "";
        let focuscheck = "";
        
        let datacollectingcheck = "";
        let reasoningcheck = "";
        let datacreativitycheck = "";


        const stampTime:any = Date.now();
        bodyFormData.set('level', savelevel );
        //bodyFormData.set('post_title', saveemail );
        bodyFormData.set('Mindset-definition',savemindset);
        //curiosity
        if(savecuriositycheck === true){curiositycheck = 'edit Curiosity'}else{curiositycheck = '';}
        bodyFormData.set('attitude-Curiosity-changes', curiositycheck);
        bodyFormData.set('skill-title-Curiosity','Curiosity');
        bodyFormData.set('Curiosity-definition', savecuriosity);
        if(savecuricon === ""){savecuricon = 'none';}
        bodyFormData.set('curiosity-icon',savecuricon);
        //responsibility
        if(saveresponsibilitycheck === true ){responsibilitycheck = 'edit Responsiblity'}else{responsibilitycheck = '';}
        bodyFormData.set('attitude-Responsibility-changes', responsibilitycheck);
        bodyFormData.set('skill-title-Responsibility','Responsibility');
        bodyFormData.set('responsibility-icon' ,saveresicon);
        if(saveresicon === ""){ saveresicon = "none";}
        bodyFormData.set('Responsibility-definition',saveresponsibility);
        //empowerment
        if(saveempowermentcheck === true){empowermentcheck = 'edit Empowerment';}else{empowermentcheck = '';}
        bodyFormData.set('attitude-Empowerment-changes',empowermentcheck);
        bodyFormData.set('skill-title-Empowerment','Empowerment');
        bodyFormData.set('empowerment-icon',saveempicon);
        if(saveempicon === ""){ saveempicon = "none";}
        bodyFormData.set('Empowerment-definition',saveempowerment);
        //observation
        bodyFormData.set('observation-icon',saveobsicon);
        if(saveobsicon === ""){ saveobsicon = "none";}
        bodyFormData.set('observation-definition',saveobservation);
        //communication
        bodyFormData.set('communication-icon',savecomicon);
        if(savecomicon === ""){ savecomicon = "none";}
        bodyFormData.set('communication-definition',savecommunication);
        //collaboration
        bodyFormData.set('collaboration-definition',savecollaboration);
        if(savecolicon === ""){ savecolicon = "none";}
        bodyFormData.set('collaboration-icon',savecolicon);
        //problemsolving
        bodyFormData.set('problemsolving-definition',saveproblemsolving);
        if(saveproicon === ""){ saveproicon = "none";}
        bodyFormData.set('problemsolving-icon', saveproicon);
        //mindset 
        bodyFormData.set('your-mindset-name', saveexptitle);
        bodyFormData.set('your-first-name', savefirstname );
        bodyFormData.set('your-last-name', 'Explores');
        bodyFormData.set('color-451', '#42DD52')
        bodyFormData.set('timestamp', stampTime);
        if(savewonderawechecked === true){wonderawecheck = 'edit AweWonder';}else{wonderawecheck = '';}
        bodyFormData.set('attitude-WonderAwe', wonderawecheck);
        bodyFormData.set('wonderawe-definition', savewonderawe);
        if(saveadventurousnesschecked === true){adventurousnesscheck = 'edit Adventurousness';}else{adventurousnesscheck = '';}
        bodyFormData.set('attitude-Adventurousness', adventurousnesscheck);
        bodyFormData.set('adventurousness-definition', saveadventurousness);
        if(saverespectchecked === true){respectcheck = 'edit Respect';}else{respectcheck = '';}
        bodyFormData.set('attitude-Respect', respectcheck);
        bodyFormData.set('respect-definition', saverespect);
        if(saveempathychecked === true){empathycheck = 'edit Empathy';}else{empathycheck = '';}
        bodyFormData.set('attitude-Empathy', empathycheck);
        bodyFormData.set('empathy-definition', saveempathy);
        if(savegritchecked === true){gritcheck = 'edit Grit';}else{gritcheck = '';}
        bodyFormData.set('attitude-Grit', gritcheck);
        bodyFormData.set('grit-definition', savegrit);

        if(saveadaptabilitychecked === true){adaptabilitycheck = 'edit Adaptability';}else{adaptabilitycheck = '';}
        bodyFormData.set('attitude-adaptability', adaptabilitycheck);
        bodyFormData.set('adaptability-definition', saveadaptability);

        if(savegrowthmindsetchecked === true){growthmindsetcheck = 'edit Growth Mindset';}else{growthmindsetcheck = '';}
        bodyFormData.set('attitude-GrowthMindset', growthmindsetcheck);
        bodyFormData.set('growthmindset-definition', savegrowthmindset);

        if(savefocuschecked === true){focuscheck = 'edit Focus';}else{focuscheck = '';}
        bodyFormData.set('skill-Focus', focuscheck);
        bodyFormData.set('growthfocus-definition', savefocus);

        if(savedatacollectingchecked === true){datacollectingcheck = 'edit DataCollecting';}else{datacollectingcheck = '';}
        bodyFormData.set('skill-DataCollecting', datacollectingcheck);
        bodyFormData.set('datacollecting-definition', savedatacollecting);

        if(savereasoningchecked === true){reasoningcheck = 'edit Reasoning';}else{reasoningcheck = '';}
        bodyFormData.set('skill-Reasoning', savereasoningchecked);
        bodyFormData.set('reasoning-definition', savereasoning);

        if(savecreativitychecked === true){datacreativitycheck = 'edit Creativity';}else{datacreativitycheck = '';}
        bodyFormData.set('skill-Creativity', savecreativitychecked);
        bodyFormData.set('creatitivity-definition', savecreativity);

        bodyFormData.set('google_user_email', 'johnflottmeyer@gmail.com');//????
        bodyFormData.set('flamingo_subject', 'johnflottmeyer@gmail.com');//????

        //need to massage this all into form sdata
        PosttoServer(bodyFormData);
    }
    const checkForm = () => {
        //slide level
        console.log("validate form fields");
        //check the attitudes

        if(!expmindname){
            setWinMessage("Explorer Mindset name can't be blank");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }else{
            setIssuccess(false);
        }
        if(!firstname){
            setWinMessage("First name can't be blank");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }else{
            setIssuccess(false);
        }
        /*if(!lastname){
            setWinMessage("Last name can't be blank");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }else{
            setIssuccess(false);
        }*/
        if(!issuccess){
            console.log("success");
            publishMM(
                levelcheck,
                mindset,
                curiositycheck,
                curiosity,
                curiosityicon,
                empowermentcheck,
                empowerment,
                empowermenticon,
                responsibilitycheck,
                responsibility,
                responsibilityicon,
                observation,
                observationicon,
                communication,
                communicationicon,
                collaboration,
                collaborationicon,
                problemsolving,
                problemsolvingicon,
                firstname,
                //lastname,
                expmindname,
                wonderawechecked,
                wonderawe,
                adventurousnesschecked,
                adventurousness,
                respectchecked,
                respect,
                empathychecked,
                empathy,
                gritchecked,
                grit,
                adaptabilitychecked,
                adaptability,
                growthmindsetchecked,
                growthmindset,
                focuschecked,
                focus,
                datacollectingchecked,
                datacollecting,
                reasoningchecked,
                reasoning,
                creativitychecked,
                creativity
                );
        }

    }
    function handleLoadMindset(){
        setShowLoading(true);
        loadMindset(
        ).then(function (finalResul){
            console.log(finalResul);
            const userD = JSON.parse(finalResul);
            setLevel(userD.level);
            setMindsetDef(userD.mindset);
            setCuriosityDef(userD.curiosity);
            setResponsibilityDef(userD.responsibility);
            setEmpowermentDef(userD.empowerment);
            setCuriousityIcon(userD.curiosityicon);
            setResponsibilityIcon(userD.responsibilityicon);
            setEmpowermentIcon(userD.empowermenticon);
            setObservationDef(userD.observation);
            setCommunicationDef(userD.communication);
            setCollaborationDef(userD.collaboration);
            setProblemsolvingDef(userD.problemsolving);
            setCommunicationIcon(userD.communicationicon);
            setCollaborationIcon(userD.collaborationicon);
            setObservationIcon(userD.observationicon);
            setProblemsolvingIcon(userD.problemsolvingicon);
            setExpmindName(userD.expmindname);
            setFirstName(userD.firstname);
            //setLastName(userD.lastname);
            setWonderAweChecked(userD.wonderawecheck);
            setWonderAweDef(userD.wonderawe)
            setAdventurousnessChecked(userD.adventurousnesscheck);
            setAdventurousnessDef(userD.adventurousness);
            setRespectChecked(userD.respectcheck);
            setRespectDef(userD.respect);
            setEmpathyChecked(userD.empathycheck);
            setEmpathyDef(userD.empathy);
            setGritChecked(userD.gritcheck);
            setGritDef(userD.grit);
            setAdaptabilityChecked(userD.adaptabilitycheck);
            setAdaptabilityDef(userD.adaptability);
            setGrowthMindsetChecked(userD.growthmindsetcheck);
            setGrowthmindsetDef(userD.growthmindset);
            setFocusChecked(userD.focuscheck);
            setFocusDef(userD.focus);
            setDataCollectingChecked(userD.datacollectingcheck);
            setDatacollectingDef(userD.datacollecting);
            setReasoningChecked(userD.reasoningcheck);
            setReasoningDef(userD.reasoning);
            setCreativityChecked(userD.creativitycheck);
            setCreativityDef(userD.creativity);


        }).catch(err => {
            //console.log("e: " + err.message);
        }); 
        //).then( 
          //  q => console.log(q)
            //set the 
        //)
        //setShowLoading(false);
    }
    function handleSaveMindset(){
        setShowLoading(true);
        saveMindset(
            levelcheck,mindset,
            curiositycheck,curiosity,curiosityicon,
            empowermentcheck,empowerment,empowermenticon,
            responsibilitycheck,responsibility,responsibilityicon,
            observation,observationicon,
            communication,communicationicon,
            collaboration,collaborationicon,
            problemsolving,problemsolvingicon,
            //firstname,lastname,expmindname,
            firstname,expmindname,
            wonderawechecked,wonderawe,
            adventurousnesschecked,adventurousness,
            respectchecked,respect,
            empathychecked,empathy,
            gritchecked,grit,
            adaptabilitychecked,adaptability,
            growthmindsetchecked,growthmindset,
            focuschecked,focus,
            datacollectingchecked,datacollecting,
            reasoningchecked,reasoning,
            creativitychecked,creativity,
            )
    }
     //video 
     const platform = Capacitor.getPlatform();
     //const history = useHistory();
     var api: any = useRef<boolean>(false);
     let url: string = "";
     const [type,setType] = useState("");
    
     useEffect( () => {
       async function launchFullscreen(): Promise<void>  {
         //set type and set api etc
         //await set('url', url);
         await set('api', api.current ? "true" : "false");
         history.push('/createmindset');//trying to feed current url into history
         history.push('/fullscreen');
       }
         if(type.length >  0) launchFullscreen();
     },[ api, platform, history, type]);
   
     function launchPlayer(senturl:string){
         url = senturl;
         //console.log(senturl + "" + url);
         set('url', url).then(()=>{
           console.log(senturl);
           let someNum = Math.random();
           setType(someNum.toString());
           console.log(type);
         });
         
     }
     function checkIsSent(){
        setIssuccess(false);
        
     }
 
     //end video 
    return(
        <>
        <IonPage id="visual">
        <LoginCheck/>
        <IonHeader translucent={true} >
            <IonToolbar>
                <IonButton size="small" slot="start" color="primary" onClick={() => history.replace("/mindset/")} class="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
                <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  class="logout"><IonIcon slot="start" icon={logOutOutline}/>Log Out</IonButton>
            </IonToolbar>
        </IonHeader>
        <IonContent id="createpage" ref={contentRef} scrollEvents={true}>
        <IonGrid>
                    <IonRow>
                        <IonCol>
                        <IonLoading
                            cssClass='my-custom-class'
                            isOpen={showLoading}
                            onDidDismiss={() => setShowLoading(false)}
                            message={'Please wait...'}
                            spinner={'bubbles'}
                            duration={9000}
                        />
                             <IonAlert
                                isOpen={issuccess}
                                onDidDismiss={() => checkIsSent()}
                                cssClass="my-success-class"
                                header={winmessagetitle}
                                message={winmessage}
                                buttons={["Close"]}
                            />
                        </IonCol>
                    </IonRow>
                    </IonGrid>
                <IonSlides 
                options={slideOpts} 
                mode="ios"  
                onIonSlidesDidLoad={init}  
                ref={mySlides}
                //onIonSlideDidChange={handleSlideChange}
                onIonSlideDidChange={(event: any)=> getIndex(event)}
                > 
                    <IonSlide class="ionslide">
                    
                    <IonCard class="ioncard">
                        <IonText class="padded learntext">
                           
                            <IonText class="innertext">
                           <span>[</span>  <h3>Create</h3> <span>]</span>
                            <h5>your</h5>
                            <h2>Explorer Mindset</h2>
                            </IonText>
                            <div></div>
                            <strong></strong>
                        </IonText>
                            <p>First choose your school level</p>
                            <IonSelect onIonChange={e => setLevel(e.detail.value)} value={levelcheck} class="ion-padding toptoggle">
                            <IonSelectOption value="1848">
                                <IonLabel>Elementary</IonLabel>
                            </IonSelectOption>
                            <IonSelectOption value="2478">
                                <IonLabel>Middle</IonLabel>
                            </IonSelectOption>
                            <IonSelectOption value="2498">
                                <IonLabel>Secondary</IonLabel>
                            </IonSelectOption>
                            </IonSelect>
                            </IonCard>
                    </IonSlide>
                <IonSlide class="ionslide">
                    <IonCard class="ioncard noSwipingClass">
                    <IonText class="padded learntext">
                        <IonText class="innertext">
                           <span>[</span>  <h3>Create</h3> <span>]</span>
                        <h5>your</h5>
                        <h2>Explorer Mindset</h2>
                        </IonText>
                        <div></div>
                        <strong></strong>
                    </IonText>
                        <IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(introurl)}>Launch Video</IonButton>
                        <strong></strong>
                        <IonLabel class="toggle">Create</IonLabel>
                                <div>
                                <IonToggle checked={mindsetcheck} id="mindset" name="mindset" slot="end" onIonChange={()=> togglemindset()}></IonToggle>
                                </div>
                        
                        {(function() { //check to see if the toggle is applied
                            if(mindsetcheck){//optional rows.
                                return (
                                    <>
                                    <h2>Explorer Mindset</h2>
                                    <p>A mindset is your thoughts and ideas about something. Think about how putting yourself in a role as an explorer can help you build a positive mindset about learning.</p>
                                    <IonTextarea 
                                    name="mindset-definition" 
                                    class="textarea" 
                                    value={mindset}
                                    onIonChange={(e) => setMindsetDef(e.detail.value!)}
                                    ></IonTextarea>
                                    </>
                                )
                            }
                        })()}    
                    </IonCard>
                </IonSlide>
            <IonSlide class="ionslide">
            <IonCard class="ioncard noSwipingClass">
                <IonText class="padded learntext">
                           <span>[</span>  <h3>Create</h3> <span>]</span>
                    <h4>Curiosity</h4>
                    <div></div>
                    <strong></strong>
                </IonText>  
                <IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(curiosityurl)}>Curiosity Video</IonButton><IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(curiositynaturl)}>NatGeo Curiosity Video</IonButton>
                <strong></strong>
                <IonLabel  class="toggle">Customize</IonLabel>
                    <div>
                    <IonToggle name="curiosity" id="curiosity" checked={curiositycheck} onIonChange={() => togglecuriosity()}></IonToggle>
           
                    </div>
                {(function() { //check to see if the toggle is applied
                    if(curiositycheck && levelcheck === '2498'){//optional rows.
                        return (
                            <>
                            <h2>Curiosity</h2>
                            <p>Curiosity is the drive to discover and understand. Think about how important curiosity is to learning and in everyday life. Use the video above to help you describe what curiosity means to you</p>
                            <IonTextarea 
                            name="curiosity-definition" 
                            class="textarea" 
                            value={curiosity}
                            onIonChange={(e) => setCuriosityDef(e.detail.value!)}
                            ></IonTextarea>
                            <IonList>
                                <IonItem>
                                <IonCheckbox color="secondary"  checked={wonderawechecked} onIonChange={e => setWonderAweChecked(e.detail.checked)}/>
                                <IonLabel>Wonder, Awe</IonLabel></IonItem>
                                {(function() {
                                if(wonderawechecked){
                                    return(
                                        <IonTextarea 
                                        name="wonderawe-definition" 
                                        class="textarea" 
                                        value={wonderawe}
                                        onIonChange={(e) => setWonderAweDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                                <IonItem><IonCheckbox color="primary"  checked={adventurousnesschecked} onIonChange={e => setAdventurousnessChecked(e.detail.checked)}/>
                                <IonLabel>Adventurousness</IonLabel></IonItem>
                                {(function() {
                                if(adventurousnesschecked){
                                    return(
                                        <IonTextarea 
                                        name="adventurousness-definition" 
                                        class="textarea" 
                                        value={adventurousness}
                                        onIonChange={(e) => setAdventurousnessDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                            </IonList>
                            </>
                        )
                    }else if(curiositycheck && levelcheck !== '2498'){
                        return(
                            <>
                            <h2>Curiosity</h2>
                            <p>Curiosity is the drive to discover and understand. Think about how important curiosity is to learning and in everyday life. Use the video above to help you describe what curiosity means to you</p>
                            <IonTextarea 
                            name="curiosity-definition" 
                            class="textarea" 
                            value={curiosity}
                            onIonChange={(e) => setCuriosityDef(e.detail.value!)}
                            ></IonTextarea>
                            </>
                        )
                    }
                })()}   
            </IonCard>
            </IonSlide> 
            <IonSlide class="ionslide">
            <IonCard class="ioncard">
                <IonText class="padded learntext">
                    <span>[</span>  <h3>Create</h3> <span>]</span>
                    <h4>Responsibility</h4>
                    <div></div>
                    <strong></strong>
                </IonText>
                <IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(responsibilityurl)}>Responsibility Video</IonButton><IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(responsibilitynaturl)}>NatGeo Responsibility Video</IonButton>
                <strong></strong>
                <IonLabel class="toggle">Customize</IonLabel>
                <div>
                <IonToggle name="responsibility-definition" checked={responsibilitycheck} onIonChange={() => toggleresponsibility()}></IonToggle>
              
                </div>
                {(function() { //check to see if the toggle is applied
                    if(responsibilitycheck && levelcheck === '2498'){//optional rows.
                        return (
                            <>
                            <h2>Responsibility</h2>
                            <p>Responsibility means to show care and respect for yourself and others</p>
                            <IonTextarea 
                            name="responsibility-definition" 
                            class="textarea" 
                            value={responsibility}
                            onIonChange={(e) => setResponsibilityDef(e.detail.value!)}
                            ></IonTextarea>
                            <IonList>
                                <IonItem>
                                <IonCheckbox color="primary" checked={respectchecked} onIonChange={e => setRespectChecked(e.detail.checked)}/>
                                <IonLabel>Respect</IonLabel></IonItem>
                                {(function() {
                                if(respectchecked){
                                    return(
                                        <IonTextarea 
                                        name="respect-definition" 
                                        class="textarea" 
                                        value={respect}
                                        onIonChange={(e) => setRespectDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                                <IonItem><IonCheckbox color="primary"  checked={empathychecked} onIonChange={e => setEmpathyChecked(e.detail.checked)}/>
                                <IonLabel>Empathy</IonLabel></IonItem>
                                {(function() {
                                if(empathychecked){
                                    return(
                                        <IonTextarea 
                                        name="empathy-definition" 
                                        class="textarea" 
                                        value={empathy}
                                        onIonChange={(e) => setEmpathyDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                            </IonList>
                            </>
                        )
                    }else if(responsibilitycheck && levelcheck !== '2498'){
                        return (
                            <>
                            <h2>Responsibility</h2>
                            <p>Responsibility means to show care and respect for yourself and others</p>
                            <IonTextarea 
                            name="responsibility-definition" 
                            class="textarea" 
                            value={responsibility}
                            onIonChange={(e) => setResponsibilityDef(e.detail.value!)}
                            ></IonTextarea>
                            </>
                        )
                    }
                })()} 
            </IonCard>
            </IonSlide>
            <IonSlide class="ionslide">
            <IonCard class="ioncard">
                <IonText class="padded learntext">
                    <span>[</span>  <h3>Create</h3> <span>]</span>
                    <h4>Empowerment</h4>
                    <div></div>
                    <strong></strong>
                </IonText>
                        
        
        
        
        
        
                <IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(empowermenturl)}>Empowerment Video</IonButton><IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(empowermentnaturl)}>NatGeo Empowerment Video</IonButton>
                <strong></strong>
                <IonLabel class="toggle">Customize</IonLabel>
                <div>
                <IonToggle name="empowerment-definition" checked={empowermentcheck} onIonChange={() => toggleempowerment()}></IonToggle>

                </div>
               {(function() { //check to see if the toggle is applied
                    if(empowermentcheck && levelcheck === '2498'){//optional rows.
                        return (
                            <>
                            <h2>Empowerment</h2>
                            <p>Empowerment means to act on ideas, use talents and interests, reach goals, be adaptable, and show grit in the face of challenges</p>
                            <IonTextarea 
                            name="empowerment-definition" 
                            class="textarea" 
                            value={empowerment}
                            onIonChange={(e) => setEmpowermentDef(e.detail.value!)}
                            ></IonTextarea>
                             <IonList>
                                <IonItem>
                                <IonCheckbox color="primary" checked={gritchecked} onIonChange={e => setGritChecked(e.detail.checked)}/>
                                <IonLabel>Grit</IonLabel></IonItem>
                                {(function() {
                                if(gritchecked){
                                    return(
                                        <IonTextarea 
                                        name="grit-definition" 
                                        class="textarea" 
                                        value={grit}
                                        onIonChange={(e) => setGritDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                                <IonItem><IonCheckbox color="primary" checked={adaptabilitychecked} onIonChange={e => setAdaptabilityChecked(e.detail.checked)}/>
                                <IonLabel>Adaptability</IonLabel></IonItem>
                                {(function() {
                                if(adaptabilitychecked){
                                    return(
                                        <IonTextarea 
                                        name="adaptability-definition" 
                                        class="textarea" 
                                        value={adaptability}
                                        onIonChange={(e) => setAdaptabilityDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                                <IonItem><IonCheckbox color="primary"  checked={growthmindsetchecked} onIonChange={e => setGrowthMindsetChecked(e.detail.checked)}/>
                                <IonLabel>Growth Mindset</IonLabel></IonItem>
                                {(function() {
                                if(growthmindsetchecked){
                                    return(
                                        <IonTextarea 
                                        name="growthmindset-definition" 
                                        class="textarea" 
                                        value={growthmindset}
                                        onIonChange={(e) => setGrowthmindsetDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                            </IonList>
                            </>
                        )
                    }else if(empowermentcheck && levelcheck !== '2498'){
                        return (
                            <>
                            <h2>Empowerment</h2>
                            <p>Empowerment means to act on ideas, use talents and interests, reach goals, be adaptable, and show grit in the face of challenges</p>
                            <IonTextarea 
                            name="empowerment-definition" 
                            class="textarea" 
                            value={empowerment}
                            onIonChange={(e) => setEmpowermentDef(e.detail.value!)}
                            ></IonTextarea>
                            </>
                        )
                    }
                })()} 
            </IonCard>
            </IonSlide>
            <IonSlide class="ionslide">
            <IonCard class="ioncard">
                <IonText class="padded learntext">
                    <h3><span>[</span> Select <span>]</span></h3>
                    <h4>Visuals</h4>
                    <div></div>
                    <strong></strong>
                </IonText>
            {(function() { //check to see if the toggle is applied
                    if(!curiositycheck && !responsibilitycheck && !empowermentcheck){//optional rows.
                        return (
                            <>
                            <h2>No Attitudes selected</h2>
                            <p>Please move on to the next page.</p>
                            </>
                        )
                    }
            })()} 
            <IonGrid>
                <IonRow>
            {(function() { //check to see if the toggle is applied
            if(curiositycheck){//optional rows.
                        return (
                            <>
                            <IonCol>
                            <IonRadioGroup 
                            class="radiogroup" 
                            name="curiosityiconval" 
                            value={curiosityicon}
                            onIonChange={e => setCuriousityIcon(e.detail.value)}
                            >
                            <IonListHeader>
                            <IonLabel>
                                Curiosity
                            </IonLabel>
                            </IonListHeader>
                            
                                    
                                        <IonItem>
                                        <img src="../assets/images/icons/curiosity1.png" alt="Curious1"/>
                                        <IonRadio value="curiosity1.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/curiosity2.png" alt="Curious2"/>
                                        <IonRadio value="curiosity2.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/curiosity3.png" alt="Curious3"/>
                                        <IonRadio value="curiosity3.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/curiosity4.png" alt="Curious4"/>
                                        <IonRadio value="curiosity4.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/curiosity5.png" alt="Curious5"/>
                                        <IonRadio value="curiosity5.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/curiosity6.png" alt="Curious6"/>
                                        <IonRadio value="curiosity6.png"></IonRadio>
                                        </IonItem>
                        </IonRadioGroup>
                        </IonCol>
                        </>
                        )
                    }
                })()} 
                {(function() { //check to see if the toggle is applied
                if(responsibilitycheck){//optional rows.
                        return (
                            <>
                            <IonCol>
                            <IonRadioGroup 
                            class="radiogroup"
                            name="responsibilityiconval" 
                            value={responsibilityicon}
                            onIonChange={e => setResponsibilityIcon(e.detail.value)}
                            >
                            <IonListHeader>
                            <IonLabel>
                                Responsibility
                            </IonLabel>
                            </IonListHeader>
                                        <IonItem>
                                        <img src="../assets/images/icons/responsibility1.png" alt="Responsibility1"/>
                                        <IonRadio value="responsibility1.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/responsibility2.png" alt="Responsibility2"/>
                                        <IonRadio value="responsibility2.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/responsibility3.png" alt="Responsibility3"/>
                                        <IonRadio value="responsibility3.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/responsibility4.png" alt="Responsibility4"/>
                                        <IonRadio value="responsibility4.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/responsibility5.png" alt="Responsibility5"/>
                                        <IonRadio value="responsibility5.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/responsibility6.png" alt="Responsibility6"/>
                                        <IonRadio value="responsibility6.png"></IonRadio>
                                        </IonItem>
                            </IonRadioGroup>
                            </IonCol>
                            </>
                        )
                    }
                })()} 
                {(function() { //check to see if the toggle is applied
                    if(empowermentcheck){//optional rows.
                        return (
                            <>
                            <IonCol>
                            <IonRadioGroup 
                            class="radiogroup"
                            name="empowermenticonval" 
                            value={empowermenticon}
                            onIonChange={e => setEmpowermentIcon(e.detail.value)}
                            >
                            <IonListHeader>
                            <IonLabel>
                                Empowerment
                            </IonLabel>
                            </IonListHeader>
                                        <IonItem>
                                        <img src="../assets/images/icons/empowerment1.png" alt="Empowerment1"/>
                                        <IonRadio value="empowerment1.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/empowerment2.png" alt="Empowerment2"/>
                                        <IonRadio value="empowerment2.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/empowerment3.png" alt="Empowerment3"/>
                                        <IonRadio value="empowerment3.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/empowerment4.png" alt="Empowerment4"/>
                                        <IonRadio value="empowerment4.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/empowerment5.png" alt="Empowerment5"/>
                                        <IonRadio value="empowerment5.png"></IonRadio>
                                        </IonItem>
                                        <IonItem>
                                        <img src="../assets/images/icons/empowerment6.png" alt="Empowerment6"/>
                                        <IonRadio value="empowerment6.png"></IonRadio>
                                        </IonItem>
                            </IonRadioGroup>
                            </IonCol>
                            </>
                        )
                    }
                })()} 

                    
            </IonRow>
            </IonGrid>
            </IonCard>
            </IonSlide>
            <IonSlide class="ionslide">
            <IonCard class="ioncard">
            <IonText class="padded learntext">
                    <span>[</span><h3>Create</h3> <span>]</span>
                    <h4>Skills</h4>
                    <div></div>
                    <strong></strong>
                </IonText>
                <IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(skillseturl)}>Launch Video</IonButton>
            <IonTextarea 
            name="obervation-definition" 
            class="textarea" 
            value={observation}
            onIonChange={(e) => setObservationDef(e.detail.value!)}
            ></IonTextarea>
             {(function() { //check to see if the toggle is applied
                    if(levelcheck === '2498'){//optional rows.
                        return (
                            <>
                            <IonList>
                                <IonItem>
                                <IonCheckbox color="primary"  checked={focuschecked} onIonChange={e => setFocusChecked(e.detail.checked)}/>
                                <IonLabel>Focus</IonLabel></IonItem>
                                {(function() {
                                if(focuschecked){
                                    return(
                                        <IonTextarea 
                                        name="focus-definition" 
                                        class="textarea" 
                                        value={focus}
                                        onIonChange={(e) => setFocusDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                                <IonItem><IonCheckbox color="primary"  checked={datacollectingchecked} onIonChange={e => setDataCollectingChecked(e.detail.checked)}/>
                                <IonLabel>Data Collecting</IonLabel></IonItem>
                                {(function() {
                                if(datacollectingchecked){
                                    return(
                                        <IonTextarea 
                                        name="datacollecting-definition" 
                                        class="textarea" 
                                        value={datacollecting}
                                        onIonChange={(e) => setDatacollectingDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                })()}
                            </IonList>
                            </>
                        )
                        }
            })()} 
            <IonRadioGroup 
                class="radiogroup"
                name="observationiconval" 
                value={observationicon}
                onIonChange={e => setObservationIcon(e.detail.value)}
                >
                <IonListHeader>
                <IonLabel>
                    Observation
                </IonLabel>
                </IonListHeader>
                            <IonItem>
                            <img src="../assets/images/icons/observation1.png" alt="Observation1"/>
                            <IonRadio value="observation1.png"></IonRadio>
                            </IonItem>
                            <IonItem>
                            <img src="../assets/images/icons/observation2.png" alt="Observation2"/>
                            <IonRadio value="observation2.png"></IonRadio>
                            </IonItem>
                            <IonItem>
                            <img src="../assets/images/icons/observation3.png" alt="Observation3"/>
                            <IonRadio value="observation3.png"></IonRadio>
                            </IonItem>
                            <IonItem>
                            <img src="../assets/images/icons/observation4.png" alt="Observation4"/>
                            <IonRadio value="observation4.png"></IonRadio>
                            </IonItem>
                            <IonItem>
                            <img src="../assets/images/icons/observation5.png" alt="Observation5"/>
                            <IonRadio value="observation5.png"></IonRadio>
                            </IonItem>
                </IonRadioGroup>
            <h1>Communication</h1>
            <IonTextarea 
            name="communication-definition" 
            class="textarea" 
            value={communication}
            onIonChange={(e) => setCommunicationDef(e.detail.value!)}></IonTextarea>
            <IonRadioGroup 
                class="radiogroup"
                name="communicationiconval" 
                value={communicationicon}
                onIonChange={e => setCommunicationIcon(e.detail.value)}
            >
            
            <IonListHeader>
            <IonLabel>
                Communication
            </IonLabel>
            </IonListHeader>
                        <IonItem>
                        <img src="../assets/images/icons/communication1.png" alt="Communication1"/>
                        <IonRadio value="communication1.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/communication2.png" alt="Communication2"/>
                        <IonRadio value="communication2.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/communication3.png" alt="Communication"/>
                        <IonRadio value="communication3.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/communication4.png" alt="Communication4"/>
                        <IonRadio value="communication4.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/communication5.png" alt="Communication5"/>
                        <IonRadio value="communication5.png"></IonRadio>
                        </IonItem>
            </IonRadioGroup>
            <h1>Collaboration</h1>
            <IonTextarea 
            name="collaboration-definition" 
            class="textarea" 
            value={collaboration}
            onIonChange={(e) => setCollaborationDef(e.detail.value!)}></IonTextarea>
            <IonRadioGroup 
                class="radiogroup"
                name="collaborationiconval" 
                value={collaborationicon}
                onIonChange={e => setCollaborationIcon(e.detail.value)}
            >
            <IonListHeader>
            <IonLabel>
                Collaboration
            </IonLabel>
            </IonListHeader>
                        <IonItem>
                        <img src="../assets/images/icons/collaboration1.png" alt="Collaboration1"/>
                        <IonRadio value="collaboration1.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/collaboration2.png" alt="Collaboration2"/>
                        <IonRadio value="collaboration2.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/collaboration3.png" alt="Collaboration3"/>
                        <IonRadio value="collaboration3.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/collaboration4.png" alt="Collaboration4"/>
                        <IonRadio value="collaboration4.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/collaboration5.png" alt="Collaboration5"/>
                        <IonRadio value="collaboration5.png"></IonRadio>
                        </IonItem>
            </IonRadioGroup>
            <h1>Problem Solving</h1>
            <IonTextarea 
            name="problemsolving-definition" 
            class="textarea" 
            value={problemsolving}
            onIonChange={(e) => setProblemsolvingDef(e.detail.value!)}></IonTextarea>
             {(function() { //check to see if the toggle is applied
                    if(levelcheck === '2498'){//optional rows.
                        return (
                            <>
                            <IonList>
                                <IonItem>
                                <IonCheckbox color="primary"  checked={reasoningchecked} onIonChange={e => setReasoningChecked(e.detail.checked)}/>
                                <IonLabel>Reasoning</IonLabel></IonItem>
                                {(function() {
                                  
                                  if(reasoningchecked){
                                  
                                    return(
                                        <IonTextarea 
                                        name="reasoning-definition" 
                                        class="textarea" 
                                        value={reasoning}
                                        onIonChange={(e) => setReasoningDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                
                                })()}
                                <IonItem><IonCheckbox color="primary"  checked={creativitychecked} onIonChange={e => setCreativityChecked(e.detail.checked)}/>
                                <IonLabel>Creativity</IonLabel></IonItem>
                               {(function() {
                                   
                                if(creativitychecked){
                                    return(
                                        <IonTextarea 
                                        name="creativity-definition" 
                                        class="textarea" 
                                        value={creativity}
                                        onIonChange={(e) => setCreativityDef(e.detail.value!)}
                                        ></IonTextarea>
                                    )
                                }
                                
                                })()}
                            </IonList>
                            </>
                        )
                        }
            })()} 
            <IonRadioGroup 
                class="radiogroup"
                name="problemsolvingiconval" 
                value={problemsolvingicon}
                onIonChange={e => setProblemsolvingIcon(e.detail.value)}
            >
            <IonListHeader>
            <IonLabel>
                Problem Solving
            </IonLabel>
            </IonListHeader>
                        <IonItem>
                        <img src="../assets/images/icons/problemsolving1.png" alt="Problemsolving1"/>
                        <IonRadio value="problemsolving1.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/problemsolving2.png" alt="Problemsolving2"/>
                        <IonRadio value="problemsolving2.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/problemsolving3.png" alt="Problemsolving3"/>
                        <IonRadio value="cproblemsolving3.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/problemsolving4.png" alt="Problemsolving4"/>
                        <IonRadio value="problemsolving4.png"></IonRadio>
                        </IonItem>
                        <IonItem>
                        <img src="../assets/images/icons/problemsolving5.png" alt="Problemsolving5"/>
                        <IonRadio value="problemsolving5.png"></IonRadio>
                        </IonItem>
            </IonRadioGroup>          
                
            

            </IonCard>
            </IonSlide>
            <IonSlide class="ionslide">
            <IonCard class="ion-padding ioncard">
            <IonText class="padded learntext">
                    <span>[</span>  <h3>Create</h3> <span>]</span>
                    <h4>Final step! Customize!</h4>
                    <div></div>
                    <strong></strong>
                </IonText>
           
                <IonItem>
            <IonLabel
            style={{
                background:color,
                padding:10
            }}>My Color:</IonLabel>
            <IonSelect name="exp-color" value={color} placeholder="Select One" onIonChange={e => setColor(e.detail.value)}>
              <IonSelectOption value="#000000">Black</IonSelectOption>
              <IonSelectOption value="#0030FF">Blue</IonSelectOption>
              <IonSelectOption value="#42DD52">Green</IonSelectOption>
              <IonSelectOption value="#FFFF00">Yellow</IonSelectOption>
              <IonSelectOption value="#E56C05">Orange</IonSelectOption>
              <IonSelectOption value="#FF1B00">Red</IonSelectOption>
              <IonSelectOption value="#8A00FF">Purple</IonSelectOption>
              <IonSelectOption value="#FF00EA">Pink</IonSelectOption>
            </IonSelect>
            </IonItem>
            <IonItem>
                <IonLabel position="stacked">Mindset Name</IonLabel>
                <IonInput 
                name="expmindset-name" 
                value={expmindname}
                placeholder="Choose a Mindset name"
                onIonChange={(e) => setExpmindName(e.detail.value!)}
                ></IonInput>
            </IonItem>
            <IonItem>
                <IonLabel position="stacked">Your Name</IonLabel>
                <IonInput 
                name="first-name" 
                value={firstname}
                placeholder="Enter your first name"
                onIonChange={(e) => setFirstName(e.detail.value!)}
                ></IonInput>
            </IonItem>
            <IonButton onClick={()=>checkForm()}>Finish My Mindset</IonButton>
            </IonCard>
            </IonSlide>
            </IonSlides>
            <IonFabButton size="small" onClick={()=>scrollTop()}>top</IonFabButton>
        </IonContent>
        <IonToolbar class="slidenav">
        {(function() { //check to see what page we are one
            let buttonDisabled = false;
            if(currentcheck > 0){ buttonDisabled = false;}else{buttonDisabled = true;}
            return(
                <IonButton onClick={() => handleSlidesControlPrev() } color="primary" fill="solid" class="prev" disabled={buttonDisabled}><IonIcon icon={arrowBackOutline} class="icon" slot="icon-only"/></IonButton>
            )
        })()} 
         {(function() { //check to see if the toggle is applied
            if(isSaved !== 'none'){//optional rows.
                return (
                    <>
                    <IonButton onClick={()=>handleLoadMindset()} 
                    color="primary" 
                    fill="solid" 
                    class="load">Load Saved</IonButton> 
                    </>
                )
            }
        })()}  
        <IonButton onClick={()=>handleSaveMindset()} 
                    color="primary" 
                    fill="solid" 
                    class="save">Save</IonButton>
        {(function() { //check to see what page we are one
        let buttonDisabled = false;
            if(currentcheck <= 6){ buttonDisabled = false;}else{buttonDisabled = true;}
                return(
                    <IonButton onClick={() => handleSlidesControlNext() } color="primary" fill="solid" class="next" disabled={buttonDisabled}><IonIcon icon={arrowForwardOutline} class="icon" slot="icon-only"/></IonButton>   
                )
            
        })()} 
        </IonToolbar>
        <FooterCom/>
        </IonPage>
        </>
    );
}
export default CreateMindset;